import { Component } from '@angular/core';

@Component({
  selector: 'app-instapay-icon',
  imports: [],
  templateUrl: './instapay-icon.html',
  styleUrl: './instapay-icon.scss',
})
export class InstapayIcon {

}
